import { render } from "./Award.vue?vue&type=template&id=6e50a193&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"

import "./Award.vue?vue&type=style&index=0&id=6e50a193&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e50a193"]])

export default __exports__